<template>
  <div class="opage" v-loading.fullscreen.lock="planRemarkSaving">
    <!-- 普检单，精检单 -->
    <div>
      <detailHeader></detailHeader>
      <div style="padding: 0 24px">
        <div class="tableBody">
          <!-- 开始处理 -->
          <div class="materialToolbar">
            <el-button type="primary" class="primary" v-if="!start && isAuth(205)" @click="inspectStartInspect">
              {{ $t("message.startProcessing") }}
            </el-button>
            <el-button type="primary" v-else @click="isServiceLook = false">
              {{ $t("message.inTheProcess") }}
            </el-button>
            <!-- 服务单 -->
            <el-button type="success" :class="{ primary: item.complete_at == null }" style="margin-left: 20px"
              v-for="item in optionServiceList" :key="item.service_sn" @click="serviceLook(item)">
              {{ item.service_sn }} -{{ item.complete_at == null ? '待完成' : '已完成' }}-({{ item.cate_name }})
            </el-button>
            <el-button v-if="!isServiceLook && materialRows.length" class="materialBatchToggle"
              @click="toggleAllMaterials">
              {{ allMaterialsExpanded ? $t('message.materialCollapseAll') : $t('message.materialExpandAll') }}
            </el-button>
          </div>
          <div class="mytable" v-if="!isServiceLook">
            <div class="tul  head_title">
              <!-- 选择 -->
              <div class="tli  select">{{ $t("message.select") }}</div>
              <!-- 番号 -->
              <div class="tli  NO">{{ $t('message.mash') }}</div>
              <!-- 照片 -->
              <div class="tli ">{{ $t("message.pic") }}</div>
              <!-- 业务编辑商品属性 -->
              <div class="tli  theBusinessEditsTheCommodityProperties listTd">
                {{ $t("message.theBusinessEditsTheCommodityProperties") }}
              </div>
              <!-- 担当备注 -->
              <div class="tli remarkTd businessRemark">
                {{ $t("message.responsibleForRemarks") }}
              </div>
              <!-- 核查员备注 注:核查员就是配货 -->
              <div class="tli remarkTd distributionRemark">
                {{ $t("message.verifierSNotes") }}
              </div>
              <!-- 标签编号：与服务单详情保持相同的核对、打印和明细展示。 -->
              <div class="tli tagCell">
                {{ $t("message.tagNumber") }}
              </div>
              <!-- 附加服务 -->
              <div class="tli  listTd">
                {{ $t("message.additionalServices") }}
              </div>
              <!-- 应检品数 -->
              <div class="tli ">
                {{ $t("message.numberOfProductsToBeInspected") }}
              </div>
              <!-- 单价(元) -->
              <div class="tli ">{{ $t("message.priceYuan") }}</div>


              <!-- 普/精检数 -->
              <div class="tli jinPin">
                {{ $t("message.theNumberOfGeneralprecisionTests") }}
              </div>

              <!-- 布标反馈不良 -->
              <div class="tli ">
                <p>{{ $t("message.clothLabelFeedbackIsPoor") }}</p>
              </div>
              <!-- 物流号 -->
              <div class="tli  listTd logisticsNumber">
                {{ $t("message.logisticsNumber") }}
              </div>
              <!-- 操作 -->
              <div class="tli ">
                <p>{{ $t("message.operation") }}</p>
              </div>
            </div>
            <div class="tcon" v-for="(orderItem, orderIndex) in tableData" :key="orderIndex">
              <div class="tul tconHead">
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <!-- 提出时间 -->
                    <p>
                      {{ $t("message.forwardTime") }}：
                    </p>
                    <p>{{ orderItem.submit_at }}</p>
                  </div>
                </div>
                <div class="tconHeadOpt yellowFont " style="flex:1.5">
                  <!-- 普检单   -->
                  {{ orderItem.inspect_sn }}
                  <span class="redFont"> </span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 配货   -->
                  {{ $t("message.distribution") }}：
                  <span>{{ orderItem.p_admin != null ? orderItem.p_admin.realname : '' }} </span>
                </div>
                <div class="tconHeadOpt" style="flex:1.5">
                  <!-- 普/精检员   -->
                  {{ $t("message.generalQualityInspector") }}：
                  <span>{{ orderItem.j_admin != null ? orderItem.j_admin.realname : '' }} </span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 布标处理   -->
                  {{ $t("message.clothLabelTreatment") }}：
                  <span>
                    {{ orderItem.label_admin != null ? orderItem.label_admin.realname : "" }}
                  </span>
                </div>
                <div class="tconHeadOpt flexDirColumn">
                  <div>
                    <p>
                      <router-link :to="'/orderPaymentDetail?order_sn=' + orderItem.order.order_sn" class="yellowFont"
                        target="_blank">
                        {{ orderItem.order.order_sn }}
                      </router-link>
                    </p>
                    <p>{{ orderItem.order.user ? orderItem.order.user.realname : '' }}</p>
                  </div>
                </div>
                <div class="tconHeadOpt">
                  <!-- 交易号 -->
                  {{ $t("message.transactionNumber") }}
                  <span class="yellowFont">{{ orderItem.purchase_no }}</span>
                </div>
                <div class="tconHeadOpt">
                  <!-- 业务 -->
                  {{ $t("message.business") }}：
                  {{ orderItem.order.y_admin != null ? orderItem.order.y_admin.realname : '' }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 采购 -->
                  {{ $t("message.purchase") }}：
                  {{ orderItem.order.g_admin != null ? orderItem.order.g_admin.realname : '' }}
                </div>
                <div class="tconHeadOpt">
                  <!-- 配货 -->
                  {{ $t("message.distribution") }}：
                  {{ orderItem.order.p_admin != null ? orderItem.order.p_admin.realname : '' }}
                </div>
              </div>
              <!-- 商品行及辅料只读信息：辅料面板与商品行保持同一组显示/隐藏状态 -->
              <div class="inspectionGoodsGroup" v-for="(goodsItem, goodsIndex) in orderItem.list"
                :key="goodsItem.inspect_detail_id || goodsIndex">
              <div class="tul tbo">
                <!-- 选择 -->
                <div class="tli  select">
                  <el-checkbox v-model="goodsItem.checked" @change="changeItem" :disabled="!start"></el-checkbox>
                </div>
                <div class="tli  NO">
                  <!-- 辅料标识：悬停后展示 material 返回的辅料详情 -->
                  <div v-if="isMaterial(goodsItem)" class="materialMarkTip" @click.stop>
                    <MaterialMarkTip :material-id="goodsItem.material_id || (goodsItem.material && goodsItem.material.id)"
                      :user-id="orderItem.order.user.id" :detail="goodsItem.material || {}" />
                  </div>
                  {{ goodsItem.sorting }}
                  <!-- 展开入口始终显示；辅料只读，业务可编辑检品要求。 -->
                  <el-button class="materialToggle" type="text" size="mini"
                    @click.stop="toggleMaterial(goodsItem)">
                    {{ goodsItem.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
                    <i :class="goodsItem.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                  </el-button>
                </div>
                <!-- 照片 -->
                <div class="tli ">
                  <div>

                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="goodsItem.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="goodsItem.link" target="_blank" slot="reference">
                        <img :src="goodsItem.pic" alt="" style="width: 60px; height: 60px" />
                      </a>
                    </el-popover>
                    <!-- 打标 -->
                    <p style="margin-top: 10px;" v-if="[12911].includes(orderItem.order.user.id)">
                      <el-button type="primary" size="mini" @click="labeling(goodsItem)">打标</el-button>
                    </p>
                  </div>
                </div>
                <!-- 业务编辑商品属性 -->
                <div class="tli   listTd">
                  <el-popover placement="bottom" trigger="hover">
                    <p v-for="(goodsDetailItem, goodsDetailIndex) in goodsItem.detail_y" :key="goodsDetailIndex">
                      {{ goodsDetailItem.key }}：
                      {{ goodsDetailItem.value }}
                    </p>
                    <div slot="reference">
                      <p v-for="(goodsDetailItem, goodsDetailIndex) in goodsItem.detail_y"
                        :key="'goodsDetail' + goodsDetailIndex">
                        {{ goodsDetailItem.key }}：
                        {{ goodsDetailItem.value }}
                      </p>
                    </div>
                  </el-popover>
                </div>
                <!-- 担当备注 -->
                <div class="tli remarkTd businessRemark">
                  <div style="width: 100%;">
                    <el-popover placement="top-start" width="450" trigger="hover">
                      <p style="font-size: 24px;padding: 10px;">{{ goodsItem.y_remark }}</p>
                      <textarea disabled v-model="goodsItem.y_remark" slot="reference"></textarea>
                    </el-popover>
                  </div>
                </div>
                <!-- 核查员备注 注:核查员就是配货 -->
                <div class="tli remarkTd distributionRemark">
                  <div style="width: 100%;">
                    <el-popover placement="top-start" width="450" trigger="hover">
                      <p>{{ goodsItem.p_remark }}</p>
                      <textarea disabled v-model="goodsItem.p_remark" slot="reference"></textarea>
                    </el-popover>
                  </div>
                </div>
                <!-- 标签编号 -->
                <div class="tli tagCell tagListCell">
                  <div class="tag-content" v-for="(tag, tagIndex) in getOrderTags(goodsItem)"
                    :key="tag.id || tagIndex">
                    <div class="tag-actions">
                      <el-button type="danger" size="mini"
                        @click="labelCheck(orderItem.order.order_sn, tag.id)">核对</el-button>
                      <!-- 未打印标签使用success颜色，已打印标签保留原有颜色。 -->
                      <el-button :type="tag.is_print ? 'primary' : 'success'" size="mini"
                        @click="printTag(goodsItem, tag)">
                        {{ tag.is_print ? '已打印' : '打印' }}
                      </el-button>
                    </div>
                    <div class="tag-record">
                      <div class="tag-field"><span class="tag-label">类别</span><span class="tag-value">{{ tag.type }}</span></div>
                      <div class="tag-field"><span class="tag-label">标签号</span><span class="tag-value">{{ tag.no }}</span></div>
                      <div class="tag-field"><span class="tag-label">商品码</span><span class="tag-value">{{ tag.goods_no }}</span></div>
                      <div class="tag-field">
                        <span class="tag-label">标签数量</span>
                        <span class="tag-value tag-count-value">
                          <span>{{ tag.num }}</span>
                          <!-- 纯文本标与配送单一致，放在标签数量行并通过 hide 模式打印。 -->
                          <el-button type="primary" size="mini" @click="printTag(goodsItem, tag, 'hide')">
                            {{ $t("message.plainTextLabel") }}
                          </el-button>
                        </span>
                      </div>
                      <div class="tag-field"><span class="tag-label">文本描述1</span><span class="tag-value">{{ tag.text_line_one }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本描述2</span><span class="tag-value">{{ tag.text_line_two }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本描述3</span><span class="tag-value">{{ tag.text_line_three }}</span></div>
                      <div class="tag-field"><span class="tag-label">文本描述4</span><span class="tag-value">{{ tag.text_line_four }}</span></div>
                    </div>
                  </div>
                </div>
                <!-- 附加服务 -->
                <div class="tli  listTd">
                  <div>
                    <el-tag v-if="Number(goodsItem.is_fba_pre) === 1" type="success" size="mini">
                      标签前置处理
                    </el-tag>
                    <div slot="reference">
                      <p v-for="(optionItem, optionIndex) in goodsItem.option" :key="'option' + optionIndex"
                        style="color: rgb(3, 110, 184);">
                        {{ optionIndex + 1 }} {{ optionItem.name }} *
                        {{ optionItem.num }} * {{ optionItem.price }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- 待提交检品数 -->
                <div class="tli ">
                  {{ goodsItem.num }}
                </div>
                <!-- 单价(元) -->
                <div class="tli ">
                  {{ goodsItem.confirm_price }}
                </div>

                <!-- 普/精检实检数 -->
                <div class="tli jinPin">
                  <div class="template">
                    <!--普/精检实检数  -->
                    <div class="row">
                      <div class="label">{{ $t("message.theNumberOfGeneralprecisionTests") }}:</div>
                      <div class="value"> <el-input v-model="goodsItem.inspect_num" onfocus="this.select()"
                          :disabled="!start" type="number"></el-input></div>
                    </div>
                    <!--普/普/精检数量差   -->
                    <div class="row">
                      <div class="label">{{ $t("message.generalqualityInspectionQuantityIsPoor") }}:</div>
                      <div class="value"> {{ goodsItem.inspect_num - goodsItem.num }}</div>
                    </div>
                    <!--普/精检不良数  -->
                    <div class="row">
                      <div class="label">{{ $t("message.theNumberOfBadSpermatologicalTests") }}:</div>
                      <div class="value"> <el-input v-model="goodsItem.inspect_bad_num" onfocus="this.select()"
                          :disabled="!start" type="number"></el-input></div>
                    </div>
                  </div>
                </div>
                <!-- 布标反馈不良 -->
                <div class="tli ">
                  <div>
                    <!-- 应检品 -->
                    <p>
                      {{ $t("message.goodsToBeInspected") }}:{{ goodsItem.label_should_num }}
                    </p>
                    <!--实检数   -->
                    <p>
                      {{ $t("message.checkNumber") }}:{{ goodsItem.label_num }}
                    </p>
                    <!-- 数量差 -->
                    <p>
                      {{ $t("message.poorQuantity") }}:
                      {{ goodsItem.label_should_num - goodsItem.label_num - goodsItem.label_bad_num }}
                    </p>
                    <!-- 不良数 -->
                    <p>
                      {{ $t("message.adverseNumber") }}:{{ goodsItem.label_bad_num }}
                    </p>
                  </div>
                </div>
                <!-- 物流号 -->
                <div class="tli  listTd logisticsNumber">
                  <div>
                    <el-popover placement="bottom" trigger="hover">
                      <p v-for="express in goodsItem.order_purchase_express" :key="express.id">
                        {{ express.express_no }}
                      </p>
                      <div slot="reference">
                        <p v-for="express in goodsItem.order_purchase_express" :key="express.id">
                          {{ express.express_no }}
                        </p>
                      </div>
                    </el-popover>
                  </div>
                </div>
                <!-- 操作 -->
                <div class="tli ">
                  <div>
                    <!-- 1868标签打印送检唛头 -->
                    <p v-if="[1868].includes(orderItem.order.user.id)" style="margin-bottom: 10px;">
                      <el-button style="width: 75px" type="success" size="small"
                        @click="label1868Print(orderItem, goodsItem, 'inspection')" :disabled="!start" class="primary">
                        送检唛头
                      </el-button>
                    </p>
                    <!-- 上架唛头 -->
                    <p v-if="[1868].includes(orderItem.order.user.id)">
                      <el-button style="width: 75px" type="success" size="small"
                        @click="label1868Print(orderItem, goodsItem, 'putOnShelves')" :disabled="!start"
                        class="primary">
                        上架唛头
                      </el-button>
                    </p>
                    <p v-if="[329990, 331032].includes(orderItem.order.user.id)" style="margin-bottom: 10px;">
                      <el-button size="small" type="primary" class="primary"
                        @click="TJKDprintLabel(goodsItem, 'pint7x4positive')">7*4正面</el-button>
                    </p>
                    <p class="row" style="margin-bottom: 10px;"
                      v-if="[329990, 331032].includes(orderItem.order.user.id)">
                      <el-button size="small" type="primary" class="primary"
                        @click="TJKDprintLabel(goodsItem, 'print7x4reverse')">7*4背面</el-button>
                    </p>
                    <p class="row" v-if="[329990, 331032].includes(orderItem.order.user.id)">
                      <el-button size="small" type="primary" class="primary"
                        @click="TJKDprintLabel(goodsItem, 'pint9x95positive')">9*9.5正面</el-button>
                    </p>
                  </div>

                </div>
              </div>
              <!-- 检品详情左侧辅料只读，右侧检品要求仅业务可编辑。 -->
              <div v-show="goodsItem.materialExpanded" class="materialRequirements">
                <div class="materialRequirementsList">
                  <MaterialInfo :list="goodsItem.material_list" :order-quantity="goodsItem.num"
                    :user-id="orderItem.order.user.id" :editable="false" :removable="false" />
                </div>
                <div class="materialRequirementsRemark">
                  <div class="requirementItem">
                    <label>{{ $t('message.productV2InspectionRequirement') }}</label>
                    <el-input v-model="goodsItem.inspect_remark" type="textarea" :rows="4" resize="none"
                      :readonly="!isBusiness" @blur="savePlanRemark(goodsItem, 'inspect_remark')" />
                  </div>
                </div>
              </div>
              </div>
            </div>
            <!-- 数据为空 -->
            <div class="tul tNullData" v-if="tableData.length == 0">
              {{ $t("message.dataIsNull") }}
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remarkList" v-if="!isServiceLook">
          <div class="item">
            <!-- 业务订单备注： -->
            <h6>{{ $t("message.serviceOrderRemarks") }}：</h6>
            <div class="remark-box">
              <div class="items" v-for="(item, index) in remarkSet.order_remark_set" :key="index">
                <div class="order">{{ item.order_Sn }}</div>
                <div class="remark">{{ item.y_remark }}</div>
              </div>
            </div>
          </div>
          <!-- 检品单备注： -->
          <div class="item">
            <h6>{{ $t("message.remarksOnInspectionList") }}：</h6>
            <div class="remark-box">
              <div class="items" v-for="(item, index) in remarkSet.inspect_remark_set" :key="index">
                <div class="order">{{ item.inspect_sn }}</div>
                <div class="remark">{{ item.inspect_remark }}</div>
              </div>
            </div>
          </div>
          <!-- 复检原因-->
          <div class="item" v-if="isRecheck == 1">
            <div class="remark-box" v-for="(item, index) in remarkSet.inspect_recheck_set" :key="index">
              <h6>
                {{ $t("message.reasonForReinspection") }}：{{ item.recheck_reason_name }}
              </h6>
              <div class="items">
                <!-- 具体原因 -->
                <div class="remark">{{ item.recheck_reason_detail }}</div>
                <!-- 是否需要布标处理： -->
                <!-- 是否需要计算绩效 -->
                <div class="order radio">
                  <p>
                    <span> {{ $t("message.whetherToClothLabels") }} :</span>
                    {{ item.is_need_label == 1 ? "是" : "否" }}
                  </p>
                  <p>
                    <span>
                      {{ $t("message.whetherPerformanceNeedsToBeCalculated") }}
                      :</span>{{ item.is_need_performance == 1 ? "是" : "否" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务单详情 -->
        <serviceDetail ref="serviceDetail" v-show="isServiceLook" />
      </div>
    </div>
    <!-- 用户操作 -->
    <div class="userOperations" v-if="start && !isServiceLook">
      <div class="check">
        <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
        <!-- 全选 -->
        <span> {{ $t("message.allChecked") }}</span>
      </div>
      <!-- 复制选择商品信息 -->
      <el-button type="primary" class="primary" @click="copyText">
        {{ $t("message.copySelectedProductInformation") }}
      </el-button>
      <!-- 临时保存 -->
      <el-button type="success" @click="inspectSaveTemp" v-if="isAuth(209)">{{ $t("message.temporaryStorage") }}
      </el-button>
      <!-- 临时提出检品不良 -->
      <el-button type="primary" class="dark" @click="inspectBadTemp">
        {{ $t("message.temporarilyPutForwardDefectiveGoods") }}
      </el-button>
      <!-- 提交布标处理 -->
      <el-button type="primary" class="primary" @click="inspectToWaitLabel" v-if="isAuth(207)">
        {{ $t("message.submitTheClothLabelForProcessing") }}
      </el-button>
      <!-- 检品完了 -->
      <el-button type="primary" @click="inspectSave" v-if="isAuth(209)">
        {{ $t("message.finishedGoods") }}
      </el-button>
    </div>
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
    <!-- 担当备注 -->
    <el-dialog :title="$t('message.responsibleForRemarks')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="980px" center>
      <div class="content">
        <div class="row" v-for="(item, index) in y_remark_list" :key="index">
          No.{{ item.sorting }} : {{ item.y_remark }}
        </div>
      </div>
    </el-dialog>
    <!-- 打标 -->
    <div v-show="false">
      <div class="labeling" ref="labeling">
        <p>{{ labelData.order_sn }}</p>
        <p>NO:{{ labelData.sorting }}</p>
        <p>Made in China</p>
      </div>
    </div>
    <!-- 送检数填写 -->
    <submitForInspectionLabel ref="submitForInspectionLabel" />
    <!-- 上架唛头打印 -->
    <putOnShelvesLabel ref="putOnShelvesLabel" />
    <!-- pint7x4positive -->
    <div v-show="false" v-if="isPrint7x4positive">
      <pint7x4positive ref="pint7x4positive" :printData="printData" />
    </div>
    <!-- pint7x4reverse -->
    <div v-show="false" v-if="isPrint7x4reverse">
      <pint7x4reverse ref="pint7x4reverse" :printData="printData" />
    </div>
    <!-- pint90x95 -->
    <div v-show="false" v-if="isPrint90x95">
      <pint90x95 ref="pint90x95" :printData="printData" />
    </div>
    <!-- 标签补打原因及打印模板与服务单详情共用。 -->
    <PrintAgain ref="printAgain" :order-detail-tag-id="printReasonTagId" :save-handler="savePrintReason"
      @print="printTagCopies" @cancel="cancelPrintReason" />
    <!-- 订单标签核对弹窗：使用订单标签扫码接口，与配送单核对隔离。 -->
    <orderTagScanList ref="orderTagScanList" />
    <div v-show="false">
      <div v-if="printTagData" ref="tagPrint">
        <tabPrint v-for="item in tabPrintNum" :key="item" :printTagData="printTagData" :isExpress="printMode" />
      </div>
    </div>
    <badMarkLabel ref="badMarkLabel" />
  </div>
</template>
<script>
import uploadFile from "@/components/uploadFile/uploadFile.vue";
import detailHeader from "@/components/header/detailHeader";
import submitForInspectionLabel from "../../inspectDetail//components/submitForInspectionLabel.vue";
import putOnShelvesLabel from "../../inspectDetail/components/putOnShelvesLabel.vue";
import pint7x4positive from "@/components/Printedsheet/tangji/pint7x4positive.vue"
import pint7x4reverse from "@/components/Printedsheet/tangji/pint7x4reverse.vue"
import pint90x95 from "@/components/Printedsheet/tangji/pint90x95.vue"
import serviceDetail from "../serviceDetail/index.vue"
import badMarkLabel from "@/views/home/problemSolving/problem_bad/components/badMarkLabel.vue"
// 标签补打弹窗和打印模板直接复用服务单详情，保证两处操作流程一致。
import PrintAgain from '@/views/orderDetail/components/printAgain'
import tabPrint from '@/components/Printedsheet/tag/tabPrint.vue'
// 检品详情与服务单详情共用订单标签核对弹窗，配送单仍使用原有核对组件。
import orderTagScanList from '@/components/common/orderTagScanList'
// 复用订单详情的辅料标识和辅料信息只读组件
import MaterialInfo from '@/components/common/materialInfo'
import MaterialMarkTip from '@/components/common/materialMarkTip'
import { getPlanRemarkSnapshot, normalizePlanRemark, shouldExpandPlanRemark } from '@/utlis/materialRemark'
export default {
  data() {
    return {
      start: false,
      remarkSet: {},
      purchase: {}, //配送单详情返回的所有数据
      recheckReason: [], //复检原因列表
      tableData: [],
      planRemarkSaving: false,
      checkedList: [], //选中的数据
      checked: false,
      workType: Number(localStorage.getItem('japanUserRoleStatus')),
      remark: "", //备注
      isRecheck: 0,// 是否是复检单
      y_remark_list: [],//担当备注
      dialogVisible: false,
      // 1868打标数据
      labelData: {
        order_sn: '',
        sorting: '',
      },
      printData: {},//唐吉打印标签数据
      isPrint7x4positive: false,
      isPrint7x4reverse: false,
      isPrint90x95: false,
      optionServiceList: [],//服务单列表
      isServiceLook: false,//是否有服务单
      service_sn: '',//服务单号
      // 标签打印临时状态：当前标签、补打标签ID、打印份数和打印模式。
      printTagData: null,
      printReasonTagId: '',
      tabPrintNum: 1,
      printMode: '',
    };
  },
  components: {
    uploadFile,
    detailHeader,
    submitForInspectionLabel,
    putOnShelvesLabel,
    pint7x4positive,
    pint7x4reverse,
    pint90x95,
    serviceDetail,
    badMarkLabel,
    PrintAgain,
    tabPrint,
    orderTagScanList,
    MaterialInfo,
    MaterialMarkTip,
  },
  metaInfo() {
    return {
      title: !this.start ? '检品待处理' : '检品处理中',
    };
  },
  computed: {
    isBusiness() {
      return this.workType === 1
    },
    materialRows() {
      return this.tableData.reduce((rows, order) => rows.concat(order.list || []), [])
    },
    allMaterialsExpanded() {
      return this.materialRows.length > 0 && this.materialRows.every(item => item.materialExpanded)
    }
  },
  created() {
    this.getData();
    this.recheckReasonMap();
    // 获取服务单列表
    let purchase_no = this.$route.query.purchase_no
    let express_no = this.$route.query.express_no
    if (purchase_no || express_no) {
      this.$api.optionServiceApi.optionServiceList({
        purchase_no, express_no, onlySelf: 1
      }).then((res) => {
        this.optionServiceList = res.data.data
      })
    }

  },
  methods: {
    // 普检/精检商品标签直接使用接口返回的 order_detail_tag。
    getOrderTags(goodsItem) {
      return Array.isArray(goodsItem && goodsItem.order_detail_tag) ? goodsItem.order_detail_tag : []
    },
    // 检品标签核对使用订单标签扫码接口，并展示该标签的扫码历史。
    labelCheck(orderSn, tagId) {
      this.$refs.orderTagScanList.open(orderSn, tagId)
    },
    // 首次打印直接登记；已打印标签再次打印前登记补打原因；mode=hide 时打印纯文本标。
    printTag(goodsItem, tag, mode = '') {
      this.printTagData = JSON.parse(JSON.stringify(tag))
      this.printMode = mode
      this.tabPrintNum = 1
      if (tag.is_print) {
        this.printReasonTagId = tag.id
        this.$refs.printAgain.dialogVisible = true
        return
      }
      this.printTagCopies(1)
      this.$api.orderApi.printTag({
        order_detail_tag_id: tag.id,
        order_detail_id: goodsItem.order_detail_id,
        type: tag.type,
        no: tag.no
      }).then(() => this.$set(tag, 'is_print', 1)).catch(error => {
        this.$message.error(error && error.msg ? error.msg : '标签打印失败')
      })
    },
    // 根据首次打印或补打时选择的数量，渲染对应份数后调用浏览器打印。
    printTagCopies(num) {
      this.tabPrintNum = Number(num) || 1
      this.$nextTick(() => {
        this.$print(this.$refs.tagPrint)
        this.printTagData = null
        this.tabPrintNum = 1
      })
    },
    // 取消补打时清空临时数据，避免下次打印沿用上一次标签和份数。
    cancelPrintReason() {
      this.printTagData = null
      this.printReasonTagId = ''
      this.tabPrintNum = 1
    },
    // 保存补打原因；保存成功后由 PrintAgain 组件继续触发实际打印。
    savePrintReason(data) {
      return this.$api.orderApi.printReasonStore(data)
    },
    // 检品商品的辅料标识及绑定数据只读展示
    isMaterial(item) {
      return Number(item.is_material) === 1 || Boolean(item.material_id) || Boolean(item.material && item.material.id)
    },
    // 检品页只显示检品要求，按该备注是否有值决定默认展开。
    initMaterialState(item) {
      this.$set(item, 'materialExpanded', shouldExpandPlanRemark(item, ['inspect'], this.isBusiness))
      this.$set(item, '_planRemarkSnapshot', getPlanRemarkSnapshot(item))
      this.$set(item, 'material_list', this.getOrderMaterialList(item))
    },
    // material_bind 中的绑定记录同时携带辅料详情和单套消耗量
    getOrderMaterialList(item) {
      if (!Array.isArray(item.material_bind)) return []
      return item.material_bind.map(binding => {
        const material = binding.material_detail || binding.material || {}
        // 绑定记录 ID 不是辅料主档 ID，库位查询等操作只使用主档字段。
        const materialId = binding.material_id || material.id
        return {
          ...material,
          ...binding,
          id: materialId,
          material_id: materialId,
          type: material.type || binding.type || {},
          consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
        }
      })
    },
    // 检品页仅切换展示状态，不触发任何辅料写入接口
    toggleMaterial(item) {
      item.materialExpanded = !item.materialExpanded
    },
    toggleAllMaterials() {
      const expanded = !this.allMaterialsExpanded
      this.materialRows.forEach(item => {
        item.materialExpanded = expanded
      })
    },
    // 有勾选时批量保存当前要求；无勾选时仅保存当前商品，沿用业务编辑权限。
    async savePlanRemark(item, col) {
      if (!this.isBusiness || this.planRemarkSaving) return
      const remark = normalizePlanRemark(item[col])
      if (item._planRemarkSnapshot && item._planRemarkSnapshot[col] === remark) return

      const selectedList = this.materialRows.filter(row => row.checked)
      const list = selectedList.length ? selectedList : [item]
      if (!list.includes(item)) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
      }
      const changedList = list.filter(row => !row._planRemarkSnapshot || row._planRemarkSnapshot[col] !== remark)
      if (!changedList.length) return
      // 使用订单明细 ID 去重，一次请求完成批量修改。
      const orderDetailIds = [...new Set(changedList.map(row => row.order_detail_id))]

      this.planRemarkSaving = true
      try {
        const res = await this.$api.orderApi.updatePlanRemark({
          order_detail_id: orderDetailIds,
          col,
          remark,
        }, { isLoading: true, resolveError: true })
        if (res.code != 0 || res.success === false) {
          item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
          return
        }
        // 同一订单明细可能重复展示；成功后同步对应行，不改其他商品或要求。
        this.materialRows.filter(row => orderDetailIds.includes(row.order_detail_id)).forEach(row => {
          this.$set(row, col, remark)
          if (!row._planRemarkSnapshot) this.$set(row, '_planRemarkSnapshot', getPlanRemarkSnapshot(row))
          row._planRemarkSnapshot[col] = remark
          this.$set(row, 'materialExpanded', true)
        })
        this.$message.success(res.msg)
      } catch (error) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
        // 失败提示由公共请求层处理，未保存行保持原值。
      } finally {
        this.planRemarkSaving = false
      }
    },
    // 获取详情数据
    getData() {
      let datas = {
        purchase_no: this.$route.query.purchase_no,
        express_no: this.$route.query.express_no,
        status: this.$route.query.status,
      };
      this.checkedList = [];
      this.checked = false;
      this.$api.inspectionApi.inspectPreview(datas).then((res) => {
        this.remarkSet = res.data.remarkSet;
        let user_id = res.data.list != false ? res.data.list[0].order.user.id : ''
        if (!user_id) return false
        this.$refs.getNotice.getNotice(user_id, "检品注意事项")
        // 处理商品列表数据
        this.processingData(res.data.list);
        this.tableData = res.data.list;
      });
    },
    // 获取复检原因所有选项
    recheckReasonMap() {
      this.$api.inspectionApi.recheckReasonMap().then((res) => {
        this.recheckReason = res.data;
      });
    },
    // 处理详情数据
    processingData(data) {
      this.y_remark_list = []
      let datas = {
        inspect_detail_ids: []
      }
      data.forEach((dataItem) => {
        // 添加收起与展开参数
        dataItem.checked = false;
        this.isRecheck = dataItem.inspect.recheck
        dataItem.list.forEach((items) => {
          items.checked = false;
          items.inspect_num = items.num
          this.initMaterialState(items)
          //显示担当备注
          this.y_remark_list.push({
            y_remark: items.y_remark,
            sorting: items.sorting
          })
          //默认填充 
          if (items.option) {
            let isFba = items.option.find(opti => opti.name == 'FBA贴标')
            if (!isFba) {
              datas.inspect_detail_ids.push(items.inspect_detail_id)
            }

            let itemData = items.option.find(opti => opti.name == '配套')
            if (itemData) {
              items.pack_should = items.pack_should ? items.pack_should : 0
              items.is_pack_should = true
            }
            // else {
            //   items.pack_should = 0
            // }
            let itemData1 = items.option.find(opti => opti.name == '气泡膜')
            if (itemData1) {
              items.bubble_should = items.bubble_should ? items.bubble_should : 0
              items.is_bubble_should = true
            }
            let itemData2 = items.option.find(opti => opti.name == '塑封')
            if (itemData2) {
              items.pseal_should = items.pseal_should ? items.pseal_should : 0
              items.is_pseal_should = true
            }
            let itemData3 = items.option.find(opti => opti.name == '真空压缩')
            if (itemData3) {
              items.vacuum_should = items.vacuum_should ? items.vacuum_should : 0
              items.is_vacuum_should = true
            }
            let itemData4 = items.option.find(opti => opti.name == '更换定制包装')
            if (itemData4) {
              items.fold_should = items.fold_should ? items.fold_should : 0
              items.is_fold_should = true

            }
          }
        });
        this.start = dataItem.list.every(
          (item) => item.inspect_start_at != null
        );
      });
      //是否有担当备注
      if (this.y_remark_list != false) {
        this.dialogVisible = true
      }
      // option数量预填
      if (datas.inspect_detail_ids != false) {
        this.$api.inspectionApi.optionServicePreview(datas).then(res => {
          data.forEach((dataItem) => {
            dataItem.list.forEach((items) => {
              res.data.detail.forEach(inspect => {
                if (inspect.inspect_detail_id == items.inspect_detail_id) {
                  items.pack_should = inspect.pack_should
                  items.bubble_should = inspect.bubble_should
                  items.pseal_should = inspect.pseal_should
                  items.vacuum_should = inspect.vacuum_should
                  items.fold_should = inspect.fold_should
                  items.pack_should_max = inspect.pack_should
                  items.bubble_should_max = inspect.bubble_should
                  items.pseal_should_max = inspect.pseal_should
                  items.vacuum_should_max = inspect.vacuum_should
                  items.fold_should_max = inspect.fold_should
                }
              })
            })
          })
        })
      }
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      let allcheck = true;
      this.tableData.forEach((item) => {
        item.list.forEach((inspect_detailItem) => {
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          } else {
            allcheck = false;
          }
        });
      });
      this.checked = allcheck;
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((inspect_detailItem) => {
          inspect_detailItem.checked = this.checked;
          if (inspect_detailItem.checked) {
            this.checkedList.push(inspect_detailItem);
          }
        });
      });
      this.$forceUpdate();
    },
    // 复制付款后订单详情链接和番号
    copyText() {
      const selectedList = []
      this.tableData.forEach((orderItem) => {
        orderItem.list.forEach((goodsItem) => {
          if (goodsItem.checked) {
            selectedList.push({
              order_sn: orderItem.order.order_sn,
              sorting: goodsItem.sorting
            })
          }
        })
      })
      if (selectedList.length === 0) {
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      }
      selectedList.sort((a, b) => Number(a.sorting) - Number(b.sorting))
      const currentUrl = window.location.href.split('#')[0]
      const copyContent = selectedList.map(item => {
        const routeUrl = this.$router.resolve({
          name: 'orderPaymentDetail',
          query: { order_sn: item.order_sn }
        }).href
        return `${currentUrl}${routeUrl}\n${item.sorting}番`
      }).join('\n')
      this.copy(copyContent)
    },
    // 获取选中商品的id
    getChioseId() {
      let ids = [];
      this.checkedList.forEach((checkedItem) => {
        ids.push(checkedItem.id);
      });
      return ids;
    },

    // 提交检品
    inspectSave() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
        express_no:this.$route.query.express_no,
      };

      let clothLabelStr = ''
      this.checkedList.forEach((item) => {
        // option有布标需要先提交布标处理
        if (item.option != null) {
          item.option.forEach(opti => {
            if ((opti.name == '缝布标' || opti.name == '取布标') && (item.label_should_num == 0)) {
              clothLabelStr += item.sorting + ','
            }
          })
        }
        const inspectItem = {
          id: item.inspect_detail_id,
          inspect_num: item.inspect_num,
          inspect_bad_num: item.inspect_bad_num,
        }
        datas.list.push(inspectItem);
      });

      if (clothLabelStr) {
        return this.$alert(clothLabelStr + '番,需要提交布标，不能操作检品完了', '提示', {
          confirmButtonText: '确定',
          center: true
        });
      }

      this.$confirm(this.$t("message.confirmToSubmitTheInspectionList"), {
        type: "warning",
      })
        .then(() => {
          this.$api.inspectionApi.inspectSave(datas).then((res) => {
            this.$message.success(res.msg);
            this.inspectStoreService()
            // 交易号入口不生成、不查询，也不自动弹出不良唛头。
            if (this.$route.query.express_no) this.printBadMark()
            this.getData();
          });
        })
        .catch(() => { });
    },
    // 检品生成服务单
    // 按当前入口物流号汇总并打印未打印的不良唛头。
    printBadMark() {
      const expressNo = this.$route.query.express_no
      if (!expressNo) return
      const datas = {
        status: "1",
        express_no: expressNo,
        page: 1,
        pageSize: 200,
      }
      this.$api.inspectionApi.badList(datas).then(res => {
        const badMarkMap = {}
        const inspectBadIds = []
        res.data.data.forEach(item => {
          item.list.forEach(items => {
            if (items.inspect_bad_num > 0 && Number(items.is_print) === 0 && items.bad_mark_code) {
              inspectBadIds.push(items.id)
              if (!badMarkMap[items.id]) {
                badMarkMap[items.id] = {
                  customer_attribute: items.attribute_name,
                  user_name: items.user != null ? items.user.realname + '-' + items.user.id : '',
                  bad_id: items.id,
                  bad_mark_code: items.bad_mark_code,
                  express_no: expressNo,
                  bad_num: 0,
                  checker_name: items.p_admin != null ? items.p_admin.realname : '',
                  inspector_name: item.j_admin != null ? item.j_admin.realname : '',
                  purchaser_name: items.g_admin != null ? items.g_admin.realname : '',
                  salesman_name: items.y_admin != null ? items.y_admin.realname : ''
                }
              }
              badMarkMap[items.id].bad_num += Number(items.inspect_bad_num || 0)
            }
          })
        })
        // 没有未打印的不良数据时不打开打印窗口。
        const printData = Object.values(badMarkMap)
        if (printData.length) {
          // 每条不良记录单独打印，确保条码中的不良 ID 与记录一一对应。
          this.$refs.badMarkLabel.printList(printData)
          // 记录本次汇总唛头包含的所有不良数据打印状态，避免重复弹出。
          this.$api.inspectionApi.badMarkPrint({ inspectBadIds })
        }
      })
    },
    inspectStoreService() {
      let datas = {
        list: []
      } //检品生成服务单
      this.checkedList.forEach((item) => {
        if (item.pack_should > 0 || item.bubble_should > 0 || item.pseal_should > 0 || item.vacuum_should > 0) {
          datas.list.push({
            inspect_detail_id: item.inspect_detail_id,
            pack_complete: item.pack_should,
            bubble_complete: item.bubble_should,
            pseal_complete: item.pseal_should,
            vacuum_complete: item.vacuum_should,
          });
        }

      });
      if (datas.list != false) {
        this.$api.inspectionApi.inspectStoreService(datas).then(res => {
          this.$confirm('服务单号：' + res.data, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '复制',
            type: 'warning'
          }).then(() => {

          }).catch(() => {
            this.copy(res.data)
          });
        })
      }

    },
    //开始检品
    inspectStartInspect() {
      let datas = {
        ids: [],
      };
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          datas.ids.push(items.inspect_detail_id);
        });
      });
      this.service_sn = ''
      this.isServiceLook = false
      this.$api.inspectionApi.inspectStartInspect(datas).then((res) => {
        this.$message.success(res.msg);
        this.start = true;
      });
    },
    // 检品操作界面-普检/精检临时保存
    inspectSaveTemp() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
      };
      this.checkedList.forEach((item) => {
        datas.list.push({
          id: item.inspect_detail_id,
          inspect_num: item.inspect_num,
          inspect_bad_num: item.inspect_bad_num,
          bubble_num: item.bubble_num,
          set_num: item.set_num,
        });
      });
      this.$api.inspectionApi.inspectSaveTemp(datas).then((res) => {
        this.$message.success(res.msg);
        this.getData();
      });

    },
    //提出临时不良
    inspectBadTemp() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
      };
      this.checkedList.forEach((item) => {
        const inspectItem = {
          id: item.inspect_detail_id,
          inspect_num: item.inspect_num,
          inspect_bad_num: item.inspect_bad_num,
        }
        // 交易号入口不关联物流号，因此不生成对应的不良唛头。
        if (this.$route.query.express_no) inspectItem.express_no = this.$route.query.express_no
        datas.list.push(inspectItem);
      });
      this.$api.inspectionApi.inspectBadTemp(datas).then((res) => {
        this.$message.success(res.msg);
        this.tableData.forEach((dataItem) => {
          // 添加收起与展开参数
          dataItem.checked = false;
          dataItem.list.forEach((items) => {
            items.checked = false;
          });
        });
        this.checked = false;
      });
    },
    //提交布标处理
    inspectToWaitLabel() {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let datas = {
        list: [],
      };
      this.checkedList.forEach((item) => {
        datas.list.push({
          id: item.inspect_detail_id,
          label_should_num: item.inspect_num,
        });
      });
      this.$api.inspectionApi.inspectToWaitLabel(datas).then((res) => {
        this.$message.success(res.msg);
        this.getData();
        this.checked = false;
      });
    },
    //option
    setOption(option, name) {
      let flag = false
      if (option != null) {
        flag = option.some(item => item.name == name)
      }

      return flag
    },
    // 不允许出现负数
    handleInput(value, item, type, max) {
      // 将输入值转换为数字，然后去除开头的负号
      const number = Number(value.replace(/-?\\d+(\\.\\d+)?/, ''));
      // 如果输入的是负数或者非数字，则清空输入
      if (isNaN(number) || number < 0) {
        item[type] = '';
      } else {
        // 否则更新输入值
        item[type] = number.toString();
      }
      if (value > max) {
        item[type] = max
        this.$message.error('请注意，填写的数不能大于最大可填入的值')
      }
    },
    // 打标
    labeling(goodsItem) {
      this.labelData = {
        order_sn: goodsItem.order_sn,
        sorting: goodsItem.sorting,
      }
      this.$nextTick(() => {
        this.$print(this.$refs.labeling);

      });
    },
    // 1868标签打印
    label1868Print(item, items, labelType) {
      let labelData = {
        sorting: items.sorting,
        detail_y: items.detail_y,
        order_sn: items.order_sn,
        order_detail_tag: items.order_detail_tag != false ? items.order_detail_tag[0] : '',
        confirm_num: items.confirm_num,
        inspectNum: items.num,
        type: '',
        g_name: item.order.g_admin.realname,
        p_name: item.order.p_admin.realname,
        y_name: item.order.y_admin.realname,
        user_name: item.order.user.realname,
        purchase_no: item.purchase_no,
        order_purchase_express: items.order_purchase_express != false ? items.order_purchase_express[0].express_no : '',
        inspect_detail: items.inspect_detail,
        inspect_sn: item.inspect_sn,
        j_name: item.j_admin.realname,
      }

      // 取detail_y的第一个值
      let type = items.detail_y != false ? items.detail_y[0].value : ''
      if (type.includes('／')) {
        labelData.type = type.split('／')[0]
      }
      // 没有检测类型时，取detail_y的第一个值
      if (labelData.type == '') {
        type = items.detail_y != false ? items.detail_y[1].value : ''
        if (type.includes('／')) {
          labelData.type = type.split('／')[0]
        }
      }
      // 检品标签打印
      if (labelType == 'inspection') {
        this.$refs.submitForInspectionLabel.labelData = labelData
        this.$refs.submitForInspectionLabel.printLabel()
      }
      if (labelType == 'putOnShelves') {
        labelData.inspectNum = ''
        this.$refs.putOnShelvesLabel.labelData = labelData
        this.$refs.putOnShelvesLabel.jpDialogVisible = true
      }
    },
    // 唐吉坷德打印标签
    TJKDprintLabel(item, type) {

      let datas = {
        order_sn: item.order_sn,
        order_detail_id: item.order_detail_id,
      }
      this.$api.orderApi
        .bulkExcelResult(datas)
        .then((res) => {
          if (res.data == false) return this.$message.error('打印标签数据为空，请上传标签文件')
          let content = res.data[0].content
          content.material = content.material.replace(/\n/g, '<br>')
          content.company = content.company.replace(/\n/g, '<br>')
          content.desc = content.desc.replace(/\n/g, '<br>')
          this.printData = content
          // 打印7x4positive
          if (type == 'pint7x4positive') {
            this.isPrint7x4positive = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4positive);
              this.isPrint7x4positive = false
            }, 500)
          }
          // 打印7x4positive
          if (type == 'print7x4reverse') {
            this.isPrint7x4reverse = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint7x4reverse);
              this.isPrint7x4reverse = false
            }, 500)
          }

          if (type == 'pint9x95positive') {
            this.isPrint90x95 = true
            this.$nextTick(() => {
              this.$print(this.$refs.pint90x95);
              this.isPrint90x95 = false
            }, 500)
          }
        })
    },
    // 服务单详情
    serviceLook(item) {
      this.isServiceLook = true
      this.service_sn = item.service_sn
      this.$refs.serviceDetail.datas.service_sn = item.service_sn
      this.$refs.serviceDetail.optionServiceList()
    }
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

* {
  box-sizing: border-box;
  font-family: 思源黑体;
}

.materialToolbar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .materialBatchToggle {
    margin-left: auto;
  }
}

// 标签编号列固定加宽，避免标签号和文本内容因列宽不足频繁换行。
.tagCell {
  flex: 0 0 240px !important;
  min-width: 240px;
}

// 商品行存在多个标签时，按接口顺序从上往下排列，表头仍保持居中。
.tagCell.tagListCell {
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.tag-content {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  // 单个标签使用白色背景，避免与检品详情行底色混在一起。
  background-color: #fff;
}

.tag-actions {
  // 核对按钮靠左、打印按钮靠右，充分利用标签列宽度。
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.tag-record {
  width: 100%;
  border: 1px solid #b5b5b5;
}

.tag-field {
  display: flex;
  min-height: 22px;
  border-bottom: 1px solid #b5b5b5;

  &:last-child {
    border-bottom: none;
  }
}

.tag-label {
  // 固定左侧字段名宽度并禁止换行，完整显示“文本描述1”等名称。
  flex: 0 0 96px;
  box-sizing: border-box;
  padding: 2px 4px;
  background: #f5f5f5;
  border-right: 1px solid #b5b5b5;
  white-space: nowrap;
}

.tag-value {
  flex: 1;
  min-width: 0;
  padding: 2px 4px;
  word-break: break-all;
}

// 标签数量和纯文本标入口同排展示，保持与配送单一致。
.tag-count-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  word-break: normal;

  .el-button {
    flex: none;
    margin-left: 0;
  }
}

.opage {
  min-width: 1910px;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .userOperations {
    background: #f8f8f8;
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: 10px 24px;
    border: 1px solid #edeff4;
    border-radius: 8px;
    position: sticky;
    top: 10px;
    margin: 24px 24px 0;

    .check {
      margin-right: 52px;

      span {
        margin-left: 8px;
      }


      .el-button {
        margin-left: 0;
        margin-right: 16px;
      }
    }

    .operationsRight {
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 0;
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.head {
  background: #f8f8f8;
  margin-top: 20px;
}

.tableBody {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 25px;

  .mytable {
    .head_title {
      position: sticky !important;
      top: 0;
      z-index: 999;
      background-color: #EDEFF4;
      border-radius: 4px;
      height: 40px;
      margin-bottom: 12px;
      text-align: center;
    }

    .tul {
      display: flex;
      padding: 0 12px;

    }

    .tbo {
      padding: 12px 0;
      border-bottom: 1px solid #ccc;

      /deep/.el-input__inner {
        padding: 0;
        text-align: center;
      }

      p {
        line-height: 25px;
      }
    }

    .inspectionGoodsGroup {
      position: relative;

      .materialMarkTip {
        // 辅料标识固定在番号单元格左下角，避免遮挡商品编号
        position: absolute;
        bottom: -8px;
        left: 0;
        z-index: 2;
      }

      .NO {
        // 让辅料展开按钮以番号列为定位参照，显示在番号正下方。
        position: relative;
      }

      .materialToggle {
        // 辅料展开按钮放在番号下方，并与核查上架页面保持相同的视觉样式。
        position: absolute;
        left: 50%;
        bottom: -8px;
        transform: translateX(-50%);
        min-width: 56px;
        height: 24px;
        padding: 0 6px;
        border: 0;
        border-radius: 4px;
        background-color: #ecf5ff;
        color: #409eff;

        i {
          margin-left: 2px;
          font-size: 12px;
        }
      }

      // 固定左右区域宽度，辅料超宽时在左侧滚动。
      .materialRequirements {
        display: flex;
        gap: 24px;
        min-width: 0;
        padding: 16px 20px;
        border-bottom: 1px solid #edeff4;
        background-color: #fff;
      }

      .materialRequirementsList,
      .materialRequirementsRemark {
        flex: 1 1 0;
        min-width: 0;
      }

      .materialRequirementsList {
        /deep/ .material-info-panel {
          padding: 0;
          border: 0;
        }

        /deep/ .material-list {
          display: flex;
          overflow-x: auto;
          padding: 10px 10px 8px 0;
        }

        /deep/ .material-card {
          flex: 0 0 288px;
        }

        /deep/ .empty {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 136px;
          padding: 0;
        }
      }

      .materialRequirementsRemark,
      .requirementItem {
        display: flex;
        flex-direction: column;
      }

      .requirementItem {
        flex: 1;
        min-width: 0;

        label {
          display: block;
          margin-bottom: 10px;
          color: #333;
          font-size: 14px;
          font-weight: bold;
        }

        /deep/ .el-textarea {
          display: flex;
          flex: 1;
        }

        /deep/ .el-textarea__inner {
          flex: 1;
          min-height: 96px;
          height: auto;
        }
      }
    }

    .tli {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .select,
    .NO {
      flex: 0.4;
    }

    .remarkTd {
      flex: 3;

      textarea {
        resize: none;
        width: 100%;
        height: 152px;
        padding: 10px;
        font-size: 18px;
        background-color: #fff;
        color: #000;
        border-radius: 4px;
      }
    }

    // 检品时优先展示业务备注，配货备注保留较小宽度
    .businessRemark {
      flex: 4;
    }

    .distributionRemark {
      flex: 1.5;
    }

    .listTd {
      flex: 2;
    }

    .jinPin {
      flex: 2.2;
    }

    .template {
      .row {
        display: flex;
        margin-bottom: 8px;
        line-height: 40px;

        &:nth-last-child(1) {
          margin-bottom: 0;
        }

        .label {
          flex: 1;
          margin-right: 8px;
          text-align: right;
        }

        .value {
          width: 60px;
        }
      }
    }

    .tconHead {
      display: flex;
      background-color: #545469;
      flex-direction: row;
      align-items: center;
      height: 60px;
      border-radius: 4px;
      padding: 10px 24px;
      color: #fff;



      .tconHeadOpt {
        flex: 1;
        margin-right: 48px;

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }

      .flexDirColumn {
        flex: 2;
      }
    }

    .tNullData {
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      color: #bbbec7;
    }
  }
}

.remarkList {
  margin-top: 24px;
  padding: 24px;
  background: #f8f8f8;
  border: 1px solid #edeff4;
  border-radius: 8px;
  display: flex;

  .item {
    flex: 1;
    margin-right: 48px;

    h6 {
      font-size: 18px;
      margin-bottom: 12px;
    }

    .items {
      display: flex;
      margin-bottom: 12px;

      .order {
        flex: 1;
        color: #000;
      }

      .remark {
        flex: 2;
        padding: 5px;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        height: 80px;
      }

      .radio {
        margin-left: 20px;

        p {
          font-size: 16px;
          margin-bottom: 10px;
          display: flex;

          span {
            flex: 3;
          }
        }
      }
    }
  }
}

.redFont {
  color: #fa5058;
}

.yellowFont {
  color: #f9f871;
}

.el-checkbox {
  transform: scale(1.5);
}

.el-input {
  width: 80%;
}

.content {
  max-height: 700px;
  overflow-y: auto;

  .row {
    font-size: 35px;
    margin-bottom: 20px;
  }
}

.labeling {
  padding: 30px;

  p {
    font-size: 48px;
    margin-bottom: 25px;
    text-align: center;
    color: #000;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
</style>
